import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["target", "template"]

  add(e) {
    e.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.targetTarget.insertAdjacentHTML("beforebegin", content)
  }

  remove(e) {
    e.preventDefault()
    const wrapper = e.target.closest(".group")

    if (!wrapper) return

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      this.confirmMigration(wrapper)
    }
  }

  confirmMigration(wrapper) {
    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    const migrationSelect = wrapper.querySelector("select[name*='migrate_group_id']")

    if (!destroyInput || !migrationSelect) return

    const dialog = this.buildMigrationDialog(wrapper, migrationSelect)
    document.body.appendChild(dialog)

    const select = dialog.querySelector("[data-migration-dialog-select]")
    const cancelButton = dialog.querySelector("[data-migration-dialog-cancel]")
    const confirmButton = dialog.querySelector("[data-migration-dialog-confirm]")

    cancelButton.addEventListener("click", () => this.closeMigrationDialog(dialog))
    confirmButton.addEventListener("click", () => {
      migrationSelect.value = select.value
      destroyInput.value = "1"
      wrapper.style.display = "none"
      this.closeMigrationDialog(dialog)
    })

    if (dialog.showModal) {
      dialog.showModal()
    } else {
      dialog.setAttribute("open", "")
    }
  }

  buildMigrationDialog(wrapper, migrationSelect) {
    const dialog = document.createElement("dialog")
    const select = migrationSelect.cloneNode(true)
    const accountLabel = wrapper.dataset.accountLabel || "该账号"

    select.classList.remove("hidden")
    select.className = "mt-2 block w-full h-9 rounded border border-gray-300 bg-white px-3 text-sm text-gray-900 focus:border-blue-500 focus:outline-none"
    select.dataset.migrationDialogSelect = "true"

    dialog.className = "fixed inset-0 m-auto p-0 border-none bg-transparent backdrop:bg-gray-500/75 backdrop:backdrop-blur-sm"
    dialog.innerHTML = `
      <div class="w-[420px] max-w-[calc(100vw-32px)] rounded-lg bg-white shadow-xl">
        <div class="px-6 py-5">
          <h3 class="text-base font-semibold text-gray-900">迁移并删除子账号</h3>
          <p class="mt-2 text-sm text-gray-500">删除 ${this.escapeHtml(accountLabel)} 后，当前绑定成员会迁移到选择的分组，并保持未绑定状态。</p>
          <label class="mt-4 block text-sm font-medium text-gray-700">目标分组</label>
          <div data-migration-dialog-select-container></div>
        </div>
        <div class="flex justify-end gap-3 border-t border-gray-100 px-6 py-4">
          <button type="button" data-migration-dialog-cancel class="rounded border border-gray-300 px-4 py-1.5 text-sm text-gray-600 hover:border-blue-500 hover:text-blue-600">取消</button>
          <button type="button" data-migration-dialog-confirm class="rounded bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-500">确认删除</button>
        </div>
      </div>
    `
    dialog.querySelector("[data-migration-dialog-select-container]").appendChild(select)

    return dialog
  }

  closeMigrationDialog(dialog) {
    dialog.close?.()
    dialog.remove()
  }

  escapeHtml(value) {
    const div = document.createElement("div")
    div.textContent = value
    return div.innerHTML
  }
}
